import { useMemo } from 'react';
import { Box, Tab, TabList, Tabs } from '~/commonComponents';
import { JobPostingStatus, JobPostingStatusMapper } from '~/domain/PermanentJobs';

interface IJobPostingStatusFilterPanelProps {
  counts: Record<JobPostingStatus, number>;
  onChange(tab: JobPostingStatus): void;
}

export const JobPostingStatusFilterPanel = ({
  counts,
  onChange,
}: IJobPostingStatusFilterPanelProps) => {
  const tabs = useMemo(
    () => [
      {
        title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Active),
        value: JobPostingStatus.Active,
        isVisible: true,
        dataCy: 'manage-jobs-tab-active',
      },
      {
        title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Closed),
        value: JobPostingStatus.Closed,
        isVisible: true,
        dataCy: 'manage-jobs-tab-closed',
      },
      {
        title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Suspended),
        value: JobPostingStatus.Suspended,
        isVisible: counts.suspended > 0,
        dataCy: 'manage-jobs-tab-suspended',
      },
      {
        title: `${JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Draft)}s`,
        value: JobPostingStatus.Draft,
        isVisible: true,
        dataCy: 'manage-jobs-tab-drafts',
      },
    ],
    [counts.suspended],
  );

  const handleTabChange = (idx: number) => {
    onChange(tabs[idx].value);
  };

  return (
    <Tabs tabListStyle={{ gap: 16 }} onChangeTab={handleTabChange}>
      <TabList>
        {tabs.map((it) => (
          <Tab
            PrefixComponent={
              <Box
                backgroundColor={JobPostingStatusMapper.getColor(it.value)}
                borderRadius="100%"
                height={10}
                width={10}
              />
            }
            dataCy={it.dataCy}
            isVisible={it.isVisible}
            key={it.value}
            title={`${it.title}${counts[it.value] > 0 ? ` (${counts[it.value]})` : ''}`}
            textStyle={{
              fontSize: 20,
            }}
          />
        ))}
      </TabList>
    </Tabs>
  );
};
